export default "__VITE_ASSET__e32b42eb__"